import React from "react";
import { Link } from "react-router-dom";

const ProductCard = ({ product, index }) => {
  return (
    <div
      className="dnk-product-wrapper"
      data-aos="fade-up"
      data-aos-delay={index * 100}
    >
      <Link
        to={`/products/${product.slug}`}
        className="dnk-product-card"
      >

        {/* =====================================================
            LEFT SIDE - PRODUCT IMAGE
        ===================================================== */}

        <div className="dnk-product-visual">

          <div className="product-visual-glow"></div>

          <img
            src={product.image}
            alt={`${product.name} software`}
            className="product-main-image"
          />

        </div>


        {/* =====================================================
            RIGHT SIDE - PRODUCT INFORMATION
        ===================================================== */}

        <div className="dnk-product-content">

          {/* PRODUCT CATEGORY */}

          <span className="dnk-product-tag">
            {product.tag}
          </span>


          {/* PRODUCT NAME */}

          <h2>
            {product.name}
          </h2>


          {/* PRODUCT TAGLINE */}

          <h4>
            {product.tagline}
          </h4>


          {/* PRODUCT DESCRIPTION */}

          <p>
            {product.description}
          </p>


          {/* =================================================
              PRODUCT MODULES
          ================================================= */}

          <div className="product-modules">

            {Array.isArray(product.modules) &&
              product.modules.map((module, moduleIndex) => (
                <span
                  className="product-module"
                  key={`${product.slug}-module-${moduleIndex}`}
                >
                  {module.name}
                </span>
              ))}

          </div>


          {/* =================================================
              VIEW PRODUCT
          ================================================= */}

          <div className="product-view-link">

            <span>
              View Product
            </span>

            <span className="product-arrow">
              →
            </span>

          </div>

        </div>

      </Link>
    </div>
  );
};

export default ProductCard;